import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';
import Rebuild from './components/Rebuild/Rebuild';
import * as Styles from './ProductTemplatesPage.styles';
import useLocale from '@/hooks/useLocale';
import { useHistory } from 'react-router';
import ProductTemplateAbout from './components/ProductTemplateAbout/ProductTemplateAbout';
import CurrentSOInfo from './components/CurrentSOInfo/CurrentSOInfo';
import AvailableOptions from './components/AvailableOptions/AvailableOptions';
import VpsStoreLoaderPage from '../components/VpsStoreLoaderPage/VpsStoreLoaderPage';
import VpsStoreModal from '@/pages/Products/VpsOciDetailPage/ProductTemplatesPage/commons/VpsStoreModal';
import { locale } from '@/utils/locale';

const ProductTemplatesPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id: hostingId } = useParams();
  const [modalType, setModalType] = useState('confirmRebuild');

  const vpsOci = useSelector(state => state.vpsOci);
  const rebuild = useSelector(state => state.vpsOci.rebuild);
  const { status: rebuildStatus, loading: rebuildLoading } = rebuild || {};

  const changeImage = useSelector(state => state.vpsOci.changeImage);
  const { data: changeImageData, loading: changeImageLoading } = changeImage || {};
  const { invoiceGenerated, invoiceId: imageInvoiceId } = changeImageData || {};

  const isLoading = rebuildLoading || changeImageLoading;

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: vpsOciLocale } = productDetailsLocale;

  const handleCloseModal = () => {
    setModalType(null);
  };

  useEffect(() => {
    dispatch(vpsOciActions.data.get({ hostingId }));
  }, [dispatch, hostingId]);

  useEffect(() => {
    if (invoiceGenerated) {
      history.push(`${locale('routes.billing')}${locale('routes.unpaid')}/${imageInvoiceId}?openInvoice=true`);
      return;
    }

    if (rebuildStatus === 'success') {
      history.push(`${locale('routes.products')}${locale('routes.productdetail')}/${hostingId}`);
    } else if (rebuildStatus === 'server_inactive') {
      setModalType('serverInactive');
    } else if (rebuildStatus === 'limit_exceeded') {
      setModalType('limitExceeded');
    } else if (rebuildStatus === 'not_found') {
      setModalType('notFound');
    } else if (rebuildStatus === 'unknown_error') {
      setModalType('unknownError');
    }
  }, [rebuildStatus, history, hostingId, changeImageData, invoiceGenerated, imageInvoiceId]);

  if (
    !vpsOci
    || !vpsOci.data
    || Object.keys(vpsOci).length === 0
    || Object.keys(vpsOci.data).length === 0
  ) return null;

  if (isLoading) {
    return (
      <Styles.Container data-testid="vpsoci-templates-page-loader">
        <VpsStoreLoaderPage
          title={vpsOciLocale.store.rebuild.feedback.loading}
        />
      </Styles.Container>
    );
  }

  return (
    <Styles.Container data-testid="vpsoci-templates-page">
      <ProductTemplateAbout />

      <CurrentSOInfo />

      <AvailableOptions />

      <Rebuild />

      <VpsStoreModal
        modalType={modalType}
        onClose={handleCloseModal}
      />
    </Styles.Container>
  );
};

export default ProductTemplatesPage;
